<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <v-dialog
      v-model="dialogAjoutCarteCaburant"
      max-width="60%"
      persistent
      :overlay="true"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="editCarte.carteId == null">
              Ajouter une carte carburant
            </span>
            <span v-else>Modifier une carte carburant </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-form
            id="formCarte"
            :model="formCarte"
            :rules="rules"
            ref="formCarte"
            class="demo-form-inline"
          >
            <v-layout row>
              <v-flex xs3 class="ml-1">
                <el-form-item label="Identifiant" prop="identifiant">
                  <el-input
                    :disabled="editCarte.carteId != null"
                    v-model="formCarte.identifiant"
                    name="identifiant"
                    placeholder="motif de la demande"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </v-flex>

              <v-flex xs3 class="ml-1">
                <el-form-item label="Libellé" prop="libelle">
                  <el-input
                    v-model="formCarte.libelle"
                    name="libelle"
                    placeholder="motif de la demande"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </v-flex>

              <v-flex xs3 class="ml-1">
                <el-form-item label="Montant initial" prop="montant">
                  <el-input-number
                    :disabled="editCarte.carteId != null"
                    :min="0"
                    v-model="formCarte.montant"
                    name="montant"
                    placeholder="saisir un montant"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>
              </v-flex>

              <v-flex xs3 class="ml-1">
                <el-form-item label="Zone" prop="zone">
                  <el-autocomplete
                    v-model="formCarte.zone"
                    name="zone"
                    placeholder="nom de la zone"
                    style="width: 100%"
                    :fetch-suggestions="loadZone"
                  ></el-autocomplete>
                </el-form-item>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs4 class="mr-1">
                <el-form-item label="Responsable" prop="responsable">
                  <el-select
                    filterable
                    clearable
                    v-model="formCarte.responsable"
                    placeholder="nom du responsable"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in responsables"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </v-flex>
              <v-flex xs4 class="ml-1">
                <el-form-item label="Fournisseur" prop="station">
                  <el-autocomplete
                    v-model="formCarte.station"
                    name="station"
                    placeholder="selectionner une station"
                    style="width: 100%"
                    :fetch-suggestions="loadStation"
                  ></el-autocomplete>
                </el-form-item>
              </v-flex>

              <v-flex xs5 class="ml-1">
                <el-form-item label="Description" prop="description">
                  <el-input
                    type="textarea"
                    :row="25"
                    v-model="formCarte.description"
                    name="description"
                    placeholder="description"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </v-flex>
            </v-layout>
            <v-layout row class="text-xs-right">
              <v-flex xs12>
                <el-form-item class="text-xs-right">
                  <v-btn
                    color="grey"
                    @click="
                      resetForm('formCarte');
                      closeDialog();
                    "
                    dark
                    >Annuler <v-icon right>remove_circle</v-icon></v-btn
                  >
                  <v-btn
                    v-if="editCarte.carteId == null"
                    icons
                    dark
                    color="green"
                    @click="submitForm('formCarte')"
                    >Enregistrer<v-icon right>save</v-icon></v-btn
                  >
                  <v-btn
                    v-else
                    icons
                    dark
                    color="green"
                    @click="submitForm('formCarte')"
                    >Modifier<v-icon right>edit</v-icon></v-btn
                  >
                </el-form-item>
              </v-flex>
            </v-layout>
          </el-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "AjoutCarteCarburant",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    editCarte: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],
      dialogAjoutCarteCaburant: false,
      rules: {
        identifiant: [{ required: true, message: "Veuillez saisir" }],
        libelle: [{ required: true, message: "Veuillez saisir" }],
        station: [{ required: true, message: "Veuillez saisir" }],
        zone: [{ required: true, message: "Veuillez saisir" }],
        responsable: [{ required: true, message: "Veuillez saisir" }]
      },
      formCarte: {
        identifiant: "",
        libelle: "",
        montant: "",
        zone: "",
        responsable: "",
        station: "",
        description: ""
      },
      responsables: []
    };
  },

  watch: {
    show: function(newValue, oldValue) {
      this.dialogAjoutCarteCaburant = newValue;
      if (newValue == true) {
        this.loadResponsable();
      }

      if (this.editCarte.carteId != null) {
        this.formCarte.identifiant = this.editCarte.identifiant;
        this.formCarte.montant = this.editCarte.montant;
        this.formCarte.description = this.editCarte.description;
        this.formCarte.libelle = this.editCarte.libelle;
        this.formCarte.zone = this.editCarte.zone;
        this.formCarte.station = this.editCarte.station;
        this.formCarte.responsable = this.editCarte.responsable;
      } else {
        this.formCarte.identifiant = "";
        this.formCarte.montant = "";
        this.formCarte.description = "";
        this.formCarte.libelle = "";
        this.formCarte.zone = "";
        this.formCarte.station = "";
        this.formCarte.responsable = "";
      }
    }
  },

  methods: {
    loadResponsable() {
      let url = this.domaine + "carteCarburant/user/responsable";
      this.$http.get(url).then(
        response => {
          this.responsables = response.body;
        },
        response => {
          this.$message("Chargement des responsables en cours");
        }
      );
    },

    loadZone(queryString, cb) {
      let url = this.domaine + "demandeFond/listes-zone";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadStation(queryString, cb) {
      let url = this.domaine + "carteCarburant/station/index";
      this.$http.get(url).then(
        response => {
          var links = response.body.stations;
          var results = queryString
            ? links.filter(this.createFilter(queryString))
            : links;
          cb(results);
        },
        error => {
          this.$message("Chargement de la liste des stations en cours");
        }
      );
    },

    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    closeDialog() {
      this.$emit("close");
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formCarte");
          //recuperation des demandes
          let data = new FormData(form);
          let url = "";
          if (this.editCarte.carteId == null) {
            //creer une nouvelle demande
            url = this.domaine + "carteCarburant/new/carte";
          } //modifier une demande de maintenance
          else {
            url = this.domaine + "carteCarburant/carte/edit/info";
            data.append("idCarte", this.editCarte.carteId);
          }

          data.append("station", this.formCarte.station);
          data.append("identifiant", this.formCarte.identifiant);
          data.append("libelle", this.formCarte.libelle);
          data.append("montant", this.formCarte.montant);
          data.append("description", this.formCarte.description);
          data.append("zone", this.formCarte.zone);
          data.append("responsableId", this.formCarte.responsable);
          data.append("userId", this.user.id);
          this.$http.post(url, data).then(
            response => {
              //reinitialiser le formulaire
              this.loading = false;
              this.resetForm("formCarte");
              this.formCarte.description = "";
              this.successNotif(response.body.message);
              this.closeDialog();
            },
            erreur => {
              //reinitialiser le formulaire
              this.loading = false;
              this.resetForm("formCarte");
              this.formDmd.motif = "";
              this.closeDialog();
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement de la carte"
              );
            }
          );
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    successNotif(mess = "") {
      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center",
        duration: 10000
      });
    }
  },

  mounted() {}
};
</script>

<style scoped>
.toolbar_content {
  height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/AjoutCarteCarburant.vue